import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  border-bottom: 1px solid ${(p) => p.theme.palette.primary[200]};
  background: linear-gradient(180deg, #dde6ff 0%, rgba(219, 228, 254, 0) 100%);
  backdrop-filter: blur(14.899999618530273px);
`;
